/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BotUserCreate } from '../models/BotUserCreate'
import type { paginationLinks } from '../models/paginationLinks'
import type { paginationMeta } from '../models/paginationMeta'
import type { UserCreate } from '../models/UserCreate'
import type { UserFullResource } from '../models/UserFullResource'
import type { UserResource } from '../models/UserResource'
import type { UserWrite } from '../models/UserWrite'

import type { CancelablePromise } from '../core/CancelablePromise'
import type { BaseHttpRequest } from '../core/BaseHttpRequest'

export class UsersService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * List users (with search function).
     * @returns any OK
     * @throws ApiError
     */
    public listUsers({
        page
    }: {
        /**
         * The page to retrieve starting with page 1.
         */
        page?: number
    }): CancelablePromise<{
        data: Array<UserResource>
        meta: paginationMeta
        links: paginationLinks
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/users',
            query: {
                page: page
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * Create a user.
     * @returns any Created
     * @throws ApiError
     */
    public createUser({
        requestBody
    }: {
        /**
         * User data. If bot user, only name, avatar and role_id are required.
         */
        requestBody:
            | UserCreate
            | BotUserCreate
            | {
                  /**
                   * Is user a bot?
                   */
                  bot?: boolean
              }
    }): CancelablePromise<{
        data: UserFullResource
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/users',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * Show a single user (full info).
     * @returns any OK
     * @throws ApiError
     */
    public showUser({
        id
    }: {
        /**
         * ID of the retrieved resource.
         */
        id: number
    }): CancelablePromise<{
        data: UserFullResource
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/users/{id}',
            path: {
                id: id
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`
            }
        })
    }

    /**
     * Delete a user.
     * @returns void
     * @throws ApiError
     */
    public deleteUser({
        id
    }: {
        /**
         * ID of the retrieved resource.
         */
        id: number
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/users/{id}',
            path: {
                id: id
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`
            }
        })
    }

    /**
     * Update User.
     * @returns any OK
     * @throws ApiError
     */
    public updateUser({
        id,
        requestBody
    }: {
        /**
         * ID of the retrieved resource.
         */
        id: number
        /**
         * User data. For a bot user, only the name, avatar and role_id can be changed.
         */
        requestBody: UserWrite
    }): CancelablePromise<{
        data: UserFullResource
    }> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/users/{id}',
            path: {
                id: id
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`
            }
        })
    }

    /**
     * Create user token.
     * @returns string OK
     * @throws ApiError
     */
    public createUserToken({
        id
    }: {
        /**
         * ID of the retrieved resource.
         */
        id: number
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/users/{id}/token',
            path: {
                id: id
            },
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`,
                409: `User already has a token`
            }
        })
    }

    /**
     * Delete user's token.
     * @returns void
     * @throws ApiError
     */
    public deleteUserToken({
        id
    }: {
        /**
         * ID of the retrieved resource.
         */
        id: number
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/users/{id}/token',
            path: {
                id: id
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`
            }
        })
    }
}
